import { FaTruckLoading, FaWarehouse } from "react-icons/fa";
import { getCommercialCapabilities, getCurrentElakayRole, canViewDropshippingSellerCenter } from "../../includes/pageInside/Rolle";
import { getSellCenterFeatureStatus } from "../../utils/sellCenterStatus";
import { DRAWER_NAV_GROUPS } from "./drawerNavConfig";

export const GROUP_ICON = { dropshippingIn: FaTruckLoading, provider: FaWarehouse };

const translate = (infoSource, [key, fallback]) =>
  infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.drawerNavigation?.[key] || fallback;

// Shared by every renderer of this nav (the drawer's accordion, the page's tab strip): the SAME
// wording for an inert (not-yet-active) item, never a second copy of this ternary.
export const statusLabel = (infoSource, status) => (status === "coming_back"
  ? translate(infoSource, ["comingBack", "Coming back"])
  : translate(infoSource, ["soon", "Soon"]));

// Groups/items the EFFECTIVE role (RoleSwitchDropdown-aware) may see, each with its Animation Settings
// status. Permission first: a status never grants a capability the role does not have.
export const buildDrawerNav = (infoSource) => {
  const role = getCurrentElakayRole(infoSource);
  const caps = getCommercialCapabilities(infoSource);
  const statusOf = (animationKey) => (animationKey ? getSellCenterFeatureStatus(infoSource?.allSettings, animationKey, role) : "active");
  return DRAWER_NAV_GROUPS
    .filter((group) => caps[group.capability] && (!group.needsDropshippingVisibility || canViewDropshippingSellerCenter(infoSource)))
    .map((group) => ({
      key: group.key,
      label: translate(infoSource, group.i18n),
      items: group.items
        .filter((item) => !item.capability || caps[item.capability])
        .map((item) => ({ ...item, label: translate(infoSource, item.i18n), status: statusOf(item.animationKey) })),
    }))
    .filter((group) => group.items.length);
};

// The one active item of a group for this pathname (first match wins), or null.
export const findActiveItemKey = (group, pathname) =>
  group.items.find((item) => item.match.some((re) => re.test(pathname || "")))?.key || null;
